<kw-wrapper>
    <div [ngClass]="layoutClass" class="product-grid">
        <div class="gallery">
            <div class="content-layer">
                <kw-product-gallery [gridCell]="galleryCell"></kw-product-gallery>
            </div>
        </div>
        <div class="product-detail">
            <kw-grid-cell-wrapper class="grid-cell-container cell-shadow" [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" *ngFor="let gridCell of gridCells">
                <div class="content-layer">
                    <ng-container [ngSwitch]="gridCell?.contentEnum">
                        <ng-container *ngSwitchCase="'Product Identification'">
                            <kw-product-identification [gridCell]="gridCell"></kw-product-identification>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_ID'">
                            <kw-product-identification [gridCell]="gridCell"></kw-product-identification>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_CLASSIFICATION'">
                            <kw-product-identification [gridCell]="gridCell"></kw-product-identification>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Rating'">
                            <kw-product-rating [gridCell]="gridCell"></kw-product-rating>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_RATING'">
                            <kw-product-rating [gridCell]="gridCell"></kw-product-rating>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Price'">
                            <kw-product-price [gridCell]="gridCell"></kw-product-price>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_PRICING'">
                            <kw-product-price [gridCell]="gridCell"></kw-product-price>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Selectable Features'">
                            <kw-selectable-features [gridCell]="gridCell"></kw-selectable-features>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_ADD_TO_CART'">
                            <kw-add-to-cart [gridCell]="gridCell"></kw-add-to-cart>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Short Description'">
                            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'PRODUCT_SHORT_DESC'">
                            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </ng-container>
                    </ng-container>
                </div>
            </kw-grid-cell-wrapper>
            <!-- <nb-accordion>
                <nb-accordion-item *ngFor="let gridCell of accordionCells">
                    <nb-accordion-item-header (click)="isClicked()">{{gridCell?.contentEnum}}</nb-accordion-item-header>
                    <nb-accordion-item-body>
                        <ng-container *ngIf="gridCell.contentEnum == 'PRODUCT_STD_FEATS'">
                            <kw-standard-features [gridCell]="gridCell"></kw-standard-features>
                        </ng-container>
                        <ng-container *ngIf="gridCell.contentEnum == 'PRODUCT_LONG_DESC'">
                            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </ng-container>
                    </nb-accordion-item-body>
                </nb-accordion-item>                
            </nb-accordion> -->
            <ng-container *ngIf="productShare">
                <kw-grid-cell-wrapper class="grid-cell-container cell-shadow" [ngClass]="productShare.className" [attr.cell-id]="productShare.cellId">
                    <div class="content-layer">
                        <kw-product-share [gridCell]="productShare"></kw-product-share>
                    </div>
                </kw-grid-cell-wrapper>
            </ng-container>
            <!-- <kw-grid-cell-wrapper class="grid-cell-container cell-shadow" [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" *ngFor="let gridCell of gridCells">
                <div class="content-layer">
                    <ng-container [ngSwitch]="gridCell?.contentEnum">
                        <ng-container *ngSwitchCase="'Product Identification'">
                            <kw-product-identification [gridCell]="gridCell"></kw-product-identification>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Rating'">
                            <kw-product-rating [gridCell]="gridCell"></kw-product-rating>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Price'">
                            <kw-product-price [gridCell]="gridCell"></kw-product-price>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Selectable Features'">
                            <kw-selectable-features [gridCell]="gridCell"></kw-selectable-features>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Add To Cart'">
                            <kw-add-to-cart [gridCell]="gridCell"></kw-add-to-cart>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Short Description'">
                            <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Standard Features'">
                            <kw-standard-features [gridCell]="gridCell"></kw-standard-features>
                        </ng-container>
                    </ng-container>
                </div>
            </kw-grid-cell-wrapper> -->

        </div>
        <ng-container *ngIf="tabsLoaded === true">
            <nb-tabset 
            fullWidth
            (changeTab)="onChangeTab($event)" 
            #productTab 
            class="product-tabs-set" 
            [selectedTab]="selectedTab"
            ubsDynamicTab>
                <nb-tab *ngFor="let tabCell of tabCells" tabTitle="{{tabCell?.contentEnum | enumToValue:ContentEnum}}" [tabId]="tabCell.cellId" class="product-tabs">
                    <ng-container [ngSwitch]="tabCell?.contentEnum">
                        <div *ngSwitchCase="'PRODUCT_LONG_DESC'">
                            <div *ngFor="let contentElement of tabCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                                <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                            </div>
                        </div>
                        <div *ngSwitchCase="'PRODUCT_REVIEWS'">
                            <kw-product-reviews [gridCell]="productReviews"></kw-product-reviews>
                        </div>
                    </ng-container>
                </nb-tab>
            </nb-tabset>
        </ng-container>
        <!-- <kw-grid-cell-wrapper class="grid-cell-container cell-shadow" [ngClass]="gridCell.className" [attr.cell-id]="gridCell.cellId" *ngFor="let gridCell of gridCells">
            <div class="content-layer">
                <ng-container [ngSwitch]="gridCell?.contentEnum">
                    <ng-container *ngSwitchCase="'Product Identification'">
                        <kw-product-identification [gridCell]="gridCell"></kw-product-identification>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Price'">
                        <kw-product-price [gridCell]="gridCell"></kw-product-price>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Selectable Features'">
                        <kw-selectable-features [gridCell]="gridCell"></kw-selectable-features>
                    </ng-container>
                    <ng-container *ngSwitchCase="'Product Standard Features'">
                        <kw-standard-features [gridCell]="gridCell"></kw-standard-features>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <div *ngFor="let contentElement of gridCell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </ng-container>
                </ng-container> 
            </div>
        </kw-grid-cell-wrapper> -->
    </div>
    <!-- <ng-container *ngIf="tabsLoaded === true">
        <nb-tabset 
        (changeTab)="onChangeTab($event)" 
        #productTab 
        class="product-tabs-set" 
        [selectedTab]="selectedTab"
        ubsDynamicTab>
            <nb-tab *ngFor="let tabCell of tabCells" tabTitle="{{tabCell?.contentEnum}}" [tabId]="tabCell.cellId" class="product-tabs">
                <ng-container [ngSwitch]="tabCell?.contentEnum">
                    <div *ngSwitchCase="'PRODUCT_LONG_DESC'">
                        <p>PRODUCT_LONG_DESC works</p>
                        
                    </div>
                    <div *ngSwitchCase="'PRODUCT_REVIEWS'">
                        <p>Product Reviews works</p>
                        
                    </div>
                </ng-container>
            </nb-tab>
        </nb-tabset>
    </ng-container> -->
    <!-- <ng-container *ngIf="productReviews?.contentElements?.length > 0">
        <div class="product-extra-info">
            <kw-grid-cell-wrapper class="grid-cell-container cell-shadow" [ngClass]="productReviews?.className" [attr.cell-id]="productReviews.cellId">
                <div class="content-layer">
                    <kw-product-reviews [gridCell]="productReviews"></kw-product-reviews>                   
                </div>
            </kw-grid-cell-wrapper>
        </div>
    </ng-container> -->
    <!-- <ng-container *ngIf="associatedProducts">

    </ng-container> -->
    
</kw-wrapper>
